import {Injectable, OnDestroy} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

/** Let native Back use the same draft checks as the dialog's close button. */
@Injectable({providedIn: 'root'})
export class NativeBackService implements OnDestroy {
    private handlers: {id: string; close: () => void}[] = [];
    private readonly onBack = (event: Event): void => {
        const handler = this.handlers.at(-1);
        if (!handler) return;
        event.preventDefault();
        // A confirmation above the editor must be answered before navigating.
        if (this.dialog.openDialogs.at(-1)?.id === handler.id) handler.close();
    };

    constructor(private readonly dialog: MatDialog) {
        window.addEventListener('explain:navigate-back', this.onBack);
    }

    register(id: string, close: () => void): () => void {
        const handler = {id, close};
        this.handlers.push(handler);
        return () => { this.handlers = this.handlers.filter(item => item !== handler); };
    }

    ngOnDestroy(): void {
        window.removeEventListener('explain:navigate-back', this.onBack);
    }
}
